import { useEffect } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const upsert = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Instant client-side SEO/OG injection for the browser tab and JS-aware consumers.
// (Static crawler tags live in public/index.html, baked at build/deploy.)
export default function SEOHead() {
  useEffect(() => {
    axios.get(`${API}/seo`).then(({ data }) => {
      if (data.site_title) document.title = data.site_title;
      upsert("name", "description", data.meta_description || "");
      upsert("property", "og:title", data.site_title || "");
      upsert("property", "og:description", data.meta_description || "");
      upsert("property", "og:type", "website");
      upsert("name", "twitter:card", "summary_large_image");
      upsert("name", "twitter:title", data.site_title || "");
      upsert("name", "twitter:description", data.meta_description || "");
      if (data.og_image_url) {
        upsert("property", "og:image", data.og_image_url);
        upsert("name", "twitter:image", data.og_image_url);
      }
      if (data.favicon_url) {
        let link = document.head.querySelector('link[rel="icon"]');
        if (!link) { link = document.createElement("link"); link.setAttribute("rel", "icon"); document.head.appendChild(link); }
        link.setAttribute("href", data.favicon_url);
      }
    }).catch(() => {});
  }, []);
  return null;
}
